import { useState, useEffect } from 'react';
import {
  getCartItems
} from '../utils/product-bundle-utils';

const useGetCartItems = ({
  productsFulfillmentInformation, bundleQuantity, storeId, deliveryZip, storeZip, bundleId, experienceType, bundleType
}) => {
  const [cartItems, setcartItems] = useState(null);

  useEffect(() => {
    if (productsFulfillmentInformation && bundleQuantity) {
      const cartItemsData = getCartItems({
        cartingOptions: productsFulfillmentInformation?.cartingOptions,
        storeId,
        storeZip,
        deliveryZip,
        qty: bundleQuantity,
        bundleId,
        experienceType,
        bundleType
      });

      setcartItems(cartItemsData);
    }
  }, [productsFulfillmentInformation, bundleQuantity]);

  return { cartItems };
};

export default useGetCartItems;
